import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as s } from "react";
const m = ({
  title: l,
  titleId: o,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M512.928 213.555c-241.941 0-346.411 204.672-393.92 276.736-9.515 14.464-9.493 32.939.085 47.36 47.552 71.744 151.936 274.901 393.984 274.901 242.091 0 346.091-203.989 393.749-275.861 9.557-14.4 9.557-32.853 0-47.253-47.659-71.872-151.659-275.883-393.899-275.883zm33.003 467.819c-120.64 22.891-224.469-81.173-201.451-202.069 12.821-67.392 67.072-121.771 134.443-134.571 120.661-22.912 224.448 81.173 201.451 202.069-12.821 67.371-67.072 121.749-134.443 134.571m-33.003-63.633c57.301 0 103.723-46.464 103.723-103.744S570.23 410.253 512.928 410.253c-57.301 0-103.723 46.464-103.723 103.744s46.421 103.744 103.723 103.744",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = s(m);
export {
  t as default
};
